export default "__VITE_ASSET__3d1839e6__"